export default __webpack_public_path__ + "static/media/kitchen5-beforeA-1440w.f8a5079c.webp";